import React from 'react'
import { Grid, MenuItem, withStyles } from '@material-ui/core'
import { connect } from 'react-redux'
import { FormattedMessage } from 'react-intl'
import { getStyles } from 'isotope-client'
import { change, Field, formValueSelector, reduxForm } from 'redux-form'
import { compose } from 'redux'
import PropTypes from 'prop-types'
import Select from '../../../../components/form/Select'
import ItkForm from './ItkForm'
import { getAllCultures } from '../../../fo/planning/services/planningApi'
import Autocomplete from '../../../../components/form/Autocomplete'
import classnames from 'classnames'
import CultureForm from './CultureForm'

const styles = (theme) => getStyles({
	form: {
		padding: '20px 20px 0px 20px',
		width: '100%'
	},
	row: {
		marginBottom: 15
	},
	field: {
		width: '50%'
	},
	info: {
		paddingLeft: 10
	},
	title: {
		height: 20,
		marginTop: 38,
		marginBottom: 20,
		fontSize: 18,
		fontWeight: 'normal',
		color: theme.palette.text.primary,
		paddingLeft: 10,
		paddingRight: 50
	}
})

const formattedMessageBase = 'bo.cultureItk.form'
export const FIELDS = {
	TYPE_AJOUT: { name: 'typeAjout' },
	CULTURE: { name: 'idCulture' }
}
const TYPE_OPTIONS = {
	CULTURE: 'culture',
	ITK: 'itk'
}

const AddCultureItkForm = ({
	idFerme,
	formName,
	onSubmit,
	typeAjoutSelected,
	cultureSelected,
	classes,
	handleSubmit,
	prodMinoFerme,
	change
}) => {
	const [cultures, setCultures] = React.useState([])
	React.useEffect(() => {
		getAllCultures(idFerme).then((result => setCultures(
			result.map(res => ({ label: res.nom, code: res.id }))
		)))
	}, [idFerme])

	React.useEffect(() => {
		if (typeAjoutSelected === TYPE_OPTIONS.CULTURE) {
			change('prodMino', prodMinoFerme)
		} else {
			change('prodMino', undefined)
		}
	}, [typeAjoutSelected])

	const getForm = () => {
		if (typeAjoutSelected === TYPE_OPTIONS.ITK && !!cultureSelected) {
			return <>
				<Grid container className={classnames(classes.title, classes.row)}>
					<FormattedMessage id={`${formattedMessageBase}.titleNewItk`} />
				</Grid>
				<ItkForm
					isCreation
					formName={formName}
					onSubmit={onSubmit}
					noDeleteOnUnmout
				/>
			</>
		}

		if (typeAjoutSelected === TYPE_OPTIONS.CULTURE) {
			return <>
				<Grid container className={classnames(classes.title, classes.row)}>
					<FormattedMessage id={`${formattedMessageBase}.titleNewCulture`} />
				</Grid>
				<CultureForm
					formName={formName}
					onSubmit={onSubmit}
				/>
			</>
		}

		return <></>
	}

	return (<form onSubmit={handleSubmit} className={classes.form}>
		<Grid container className={classnames(classes.info, classes.row)}>
			<FormattedMessage id={`${formattedMessageBase}.infoAjout`} />
		</Grid>
		<Grid container className={classes.row}>
			<Grid item xs={6} className={classes.field}>
				<Field
					name={FIELDS.TYPE_AJOUT.name}
					component={Select}
					label={<FormattedMessage id={`${formattedMessageBase}.fields.${FIELDS.TYPE_AJOUT.name}`} />}
					reverseBackground
				>
					{Object.values(TYPE_OPTIONS).map(type => <MenuItem key={`type-option-${type}`} value={type}>
						<FormattedMessage id={`${formattedMessageBase}.fields.ajoutOptions.${type}`} />
					</MenuItem>)}

				</Field>
			</Grid>
			{typeAjoutSelected === TYPE_OPTIONS.ITK && <Grid item xs={6} className={classes.field}>
				<Field
					name={FIELDS.CULTURE.name}
					component={Autocomplete}
					label={<FormattedMessage id={`${formattedMessageBase}.fields.${FIELDS.CULTURE.name}`} />}
					options={cultures}
					reverseBackground
				/>
			</Grid>
			}
		</Grid>
		{getForm()}
	</form>)
}

AddCultureItkForm.propTypes = {
	idFerme: PropTypes.string,
	formName: PropTypes.string,
	onSubmit: PropTypes.func,
	reset: PropTypes.func,
	typeAjoutSelected: PropTypes.string,
	cultureSelected: PropTypes.string,
	classes: PropTypes.object
}

const mapStateToProps = (state, { formName }) => {
	const formSelector = formValueSelector(formName)

	return {
		form: formName,
		typeAjoutSelected: formSelector(state, FIELDS.TYPE_AJOUT.name),
		cultureSelected: formSelector(state, FIELDS.CULTURE.name)
	}
}

const actions = {
	change
}

export default compose(
	connect(mapStateToProps, actions),
	reduxForm({
		enableReinitialize: true
	}),
	withStyles(styles)
)(AddCultureItkForm)
